// ----------------------------------------------------------------------
// icon from https://www.svgrepo.com/svg/397429/mechanic-light-skin-tone
export const tenants = [
  {
    company: 'Frigoelettrica srl',
    tenantId: 'f9adb71be80c0aa320d2ed802e1449ef',
    slogan: '---',
    mail: 'info@frigoelettrica.it',
    since: '2022-11-23T20:00:00',
    image: 'frigoelettrica.jpg',
    url: 'https://frigoelettrica.it',
  },
  {
    company: 'AVService',
    tenantId: '23331538d95671bcac8078a643b48b2b',
    slogan: 'Assistange & Validation',
    mail: 'info@avservice.it',
    since: '2025-01-16T20:00:00',
    image: 'av_logo.png',
    url: 'https://www.stefanofrasca.com/avservice',
  },
  {
    company: 'Super Company Inc.',
    tenantId: '192ee36ae02138092159b572a11ea79f',
    slogan: 'To see you need work',
    mail: 'stefanofra@gmail.com',
    since: '2024-02-01T20:00:00',
    image: 'demo.jpg',
    url: 'https://tech.intervention',
  },
];
